// extracted by mini-css-extract-plugin
export default {"condition":"_PUCK","colorWhite":"IcdiZ","colorBlack":"QUCII"};